/* Site-wide product cards — label grooming that pairs with
   custom-product-cards.css (same scope). Mirrors the PDP related band's
   script in sections/related-products.liquid, which keeps handling the
   band itself. Idempotent, interval-driven (no observers), so cards that
   arrive later — collection filtering, infinite scroll, carousels — are
   picked up on the next tick. */
(function () {
  var EXCLUDED_TEMPLATES = [
    'template-collection-samples',
    'template-collection-travel-size',
    'template-collection-pro-size'
  ];
  var EXCLUDED_CONTAINERS = '.pdpv2-related, .complementary__product--loop, #mini-cart'; // 10/8: predictive search cards are styled cards now

  function pageExcluded() {
    var body = document.body;
    if (!body) return true;
    for (var i = 0; i < EXCLUDED_TEMPLATES.length; i++) {
      if (body.classList.contains(EXCLUDED_TEMPLATES[i])) return true;
    }
    return false;
  }

  function cards() {
    var all = document.querySelectorAll('.product-index.js-product-listing');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest(EXCLUDED_CONTAINERS)) out.push(all[i]);
    }
    return out;
  }

  // Quick-add buttons render as "Add to Cart • $9.50"; the card shows the
  // price above the button, so the suffix is stripped. Products whose
  // button opens the size/shade chooser say so instead. Sold-out and other
  // non-add labels pass through untouched.
  function groomAddButtons(list) {
    for (var i = 0; i < list.length; i++) {
      var input = list[i].querySelector('input.AddtoCart');
      if (!input) continue;
      var value = input.value;
      var cut = value.indexOf(' • ');
      if (cut > -1) value = value.slice(0, cut);
      if (value.toLowerCase() === 'add to cart') {
        var chooser = list[i].querySelector('.js-shade-chooser');
        if (chooser) {
          value = chooser.classList.contains('shade-chooser--size') ? 'Choose Size' : 'Choose Shade';
        } else {
          value = 'Add to Cart';
        }
      }
      if (value !== input.value) input.value = value;
    }
  }

  // Chooser buy button: "ADD 1.7 FL OZ - 50ML • $125.00" / "SELECT OPTION"
  // become "Add to Cart · $125" / "Select a Size". Labeled by content, never
  // by the disabled flag (the add request disables it mid-flight).
  function groomChooserButtons(list) {
    for (var i = 0; i < list.length; i++) {
      var buys = list[i].querySelectorAll('.js-shade-chooser .js-shade-qv-buy');
      for (var j = 0; j < buys.length; j++) {
        var btn = buys[j];
        var next, state;
        var text = btn.textContent;
        var m = text.match(/\$[\d,]+(?:\.\d\d)?/);
        if (/sold out/i.test(text)) {
          next = 'Sold Out';
          state = 'soldout';
        } else if (m) {
          next = 'Add to Cart · ' + m[0].replace(/\.00$/, '');
          state = 'ready';
        } else {
          var sizeChooser = btn.closest('.js-shade-chooser').classList.contains('shade-chooser--size');
          next = sizeChooser ? 'Select a Size' : 'Select a Shade';
          state = 'empty';
        }
        if (btn.getAttribute('data-qv-label') !== next) btn.setAttribute('data-qv-label', next);
        if (btn.getAttribute('data-qv-state') !== state) btn.setAttribute('data-qv-state', state);
      }
    }
  }

  // Size/shade chooser (option C2, 9/28): the size buttons become a pill
  // toggle whose text comes from data-pc-label ("70 ml · $59", "20 ml
  // Travel · $19"; non-ml sizes like "3-Pack" pass through), the header
  // shows the product type from data-pc-type, and "Color:" reads "Shade:".
  // custom-product-cards.css renders all three.
  // "2.4 fl oz - 70 ml" → "70 ml", "0.7 fl oz - 20 ml (Travel)" → "20 ml
  // Travel", "2.8 fl oz - 80g Tester - No Box" → "80 g Tester", "10ml Luxe
  // (10-pack)" → "10 ml Luxe 10-pack"; names without an ml/g amount
  // ("3-Pack", "Treatment Set (5)", "Tester") pass through unchanged.
  function shortSize(value) {
    var v = value.trim();
    var amount = v.match(/(\d+(?:\.\d+)?)\s*(ml|g)\b/i);
    var tags = [];
    var pack = v.match(/(\d+)\s*-?\s*pack/i);
    if (/luxe/i.test(v)) tags.push('Luxe');
    if (pack) tags.push(pack[1] + '-pack');
    if (/tester\s*\/\s*pro/i.test(v)) tags.push('Tester/Pro');
    else if (/tester/i.test(v)) tags.push('Tester');
    else if (/\bpro\b/i.test(v)) tags.push('Pro');
    if (/travel/i.test(v)) tags.push('Travel');
    if (!amount) return v;
    return [amount[1] + ' ' + amount[2].toLowerCase()].concat(tags).join(' ');
  }

  function groomChoosers(list) {
    for (var i = 0; i < list.length; i++) {
      var chooser = list[i].querySelector('.js-shade-chooser');
      if (!chooser) continue;
      var header = chooser.querySelector('.shade-chooser__header');
      // the close x lives in the TILE's top-right corner, over the photo
      // (user 9/29: in the panel corner it floated above centred content;
      // on the title line it squeezed the name on narrow tiles). The theme's
      // own button stays in the panel (hidden) and receives the click.
      var close = chooser.querySelector('.shade-chooser__close');
      if (close && close.parentElement !== chooser) chooser.insertBefore(close, chooser.firstChild);
      if (close && !list[i].querySelector(':scope > .pc-x')) {
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'pc-x';
        x.setAttribute('aria-label', 'Close');
        x.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var btn = this.parentElement.querySelector('.shade-chooser__close');
          if (btn) btn.click();
        });
        list[i].appendChild(x);
      }
      var type = list[i].querySelector('.product_type');
      var typeText = type ? type.textContent.replace(/\u00a0/g, ' ').trim() : '';
      if (header && header.getAttribute('data-pc-type') !== typeText) header.setAttribute('data-pc-type', typeText);
      var sizes = chooser.querySelectorAll('.shade-chooser__size');
      for (var j = 0; j < sizes.length; j++) {
        var price = (sizes[j].getAttribute('data-price') || '').replace(/\.00$/, '');
        var name = shortSize(sizes[j].getAttribute('data-shade') || '');
        var label = name + (price ? ' · ' + price : '');
        if (sizes[j].getAttribute('data-pc-label') !== label) sizes[j].setAttribute('data-pc-label', label);
        // stacked rows show name left, price right
        if (sizes[j].getAttribute('data-pc-name') !== name) sizes[j].setAttribute('data-pc-name', name);
        if (sizes[j].getAttribute('data-pc-price') !== price) sizes[j].setAttribute('data-pc-price', price);
      }
      var types = chooser.querySelectorAll('.js-pc-type');
      for (var k = 0; k < types.length; k++) {
        var typeLabel = shortSize(types[k].getAttribute('data-type-key') || '');
        if (types[k].textContent !== typeLabel) types[k].textContent = typeLabel;
      }
      var lbl = chooser.querySelector('.shade-chooser__label');
      var first = lbl && lbl.firstChild;
      if (first && first.nodeType === 3 && /^\s*Color:/.test(first.nodeValue)) {
        first.nodeValue = first.nodeValue.replace('Color:', 'Shade:');
      }
    }
  }

  // Tiles with a size/shade chooser anywhere a product tile renders —
  // collection cards, carousels (homepage) and the PDP "Complete Your
  // Routine" band (.pdpv2-related) — so every chooser looks and works the
  // same (user 9/28). Predictive search, the PDP complementary slot and the
  // cart drawer stay out.
  function chooserCards() {
    var all = document.querySelectorAll('.product-index.js-product-listing');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (!all[i].querySelector('.js-shade-chooser')) continue;
      if (all[i].closest('.complementary__product--loop, #mini-cart')) continue;
      out.push(all[i]);
    }
    return out;
  }

  // Photo fit (canvas "Photo 1"): how far the chooser panel reaches up into
  // the photo's content box, plus 8px air → --pc-fit on the tile; the CSS
  // shrinks the photo by that much while the chooser is open. Measured from
  // the photo frame (not the image), so it's stable whether or not the
  // image is already shrunk; the closed chooser still has layout (it only
  // fades), so the value is ready before it opens.
  function fitPhotos(list) {
    for (var i = 0; i < list.length; i++) {
      var tile = list[i];
      var panel = tile.querySelector('.js-shade-chooser');
      var frame = tile.querySelector('.prod-image');
      if (!panel || !frame) continue;
      var fr = frame.getBoundingClientRect();
      if (!fr.height) continue;
      var padBottom = parseFloat(getComputedStyle(frame).paddingBottom) || 0;
      // carousels + PDP band: the chooser starts just under the photo — or,
      // when its content is taller than the room left in the tile, high
      // enough to fit (the photo fit below then shrinks the photo to match)
      if (tile.closest('.js-carousel, .am-protocol-carousel, .pdpv2-related')) {
        var tr = tile.getBoundingClientRect();
        var under = fr.bottom - padBottom - tr.top + 8;
        var cr = panel.getBoundingClientRect();
        var contentBottom = cr.top;
        for (var c = 0; c < panel.children.length; c++) {
          var kid = panel.children[c];
          if (kid.classList.contains('shade-chooser__close')) continue;
          var kr = kid.getBoundingClientRect();
          if (kr.height && kr.bottom > contentBottom) contentBottom = kr.bottom;
        }
        var contentH = contentBottom - cr.top + (parseFloat(getComputedStyle(panel).paddingBottom) || 0);
        var top = Math.round(Math.min(under, tr.height - contentH)) + 'px';
        if (tile.style.getPropertyValue('--pc-panel-top') !== top) tile.style.setProperty('--pc-panel-top', top);
      }
      var pr = panel.getBoundingClientRect();
      if (!pr.height) continue;
      var fit = Math.max(0, Math.round(fr.bottom - padBottom - pr.top + 8));
      var val = fit + 'px';
      if (tile.style.getPropertyValue('--pc-fit') !== val) tile.style.setProperty('--pc-fit', val);
    }
  }

  // Card photo follows the pick (user 9/29): while the chooser is open, the
  // tile's main photo shows the selected variant's own image — a shade's
  // tube, a sample pack, a bag type — and returns to the product photo when
  // the chooser closes. The image URL comes from the chooser's own buttons
  // (swatch / size / option background, or the wholesale BB size row's
  // data-image) and is re-requested at a card-sized width.
  function chosenImage(chooser) {
    var url = '';
    var typePick = chooser.querySelector('.js-pc-type[aria-pressed="true"]');
    var shadePick = chooser.querySelector('.js-shade-qv-swatch.is-selected');
    if (typePick && shadePick) {
      var spans = chooser.querySelectorAll('.js-pc-type-variant');
      for (var i = 0; i < spans.length; i++) {
        if (spans[i].getAttribute('data-shade') === shadePick.getAttribute('data-shade') &&
            spans[i].getAttribute('data-type-key') === typePick.getAttribute('data-type-key')) {
          url = spans[i].getAttribute('data-image') || '';
          break;
        }
      }
    }
    if (!url) {
      var optPick = chooser.querySelector('.shade-chooser__option--image.is-selected');
      if (optPick) url = bgUrl(optPick);
    }
    if (!url && shadePick) url = bgUrl(shadePick);
    return url ? url.replace(/([?&])width=\d+/, '$1width=900') : '';
  }

  function syncCardPhotos(list) {
    for (var i = 0; i < list.length; i++) {
      var tile = list[i];
      var chooser = tile.querySelector('.js-shade-chooser');
      var img = tile.querySelector('.prod-image img');
      if (!chooser || !img) continue;
      if (!img.hasAttribute('data-pc-src')) {
        img.setAttribute('data-pc-src', img.getAttribute('src') || '');
        img.setAttribute('data-pc-srcset', img.getAttribute('srcset') || '');
      }
      var want = chooser.hidden ? '' : chosenImage(chooser);
      if (want) {
        if (img.getAttribute('data-pc-shown') !== want) {
          img.removeAttribute('srcset');
          img.setAttribute('loading', 'eager'); // lazy delayed the swap
          img.setAttribute('src', want);
          img.setAttribute('data-pc-shown', want);
        }
      } else if (img.hasAttribute('data-pc-shown')) {
        img.setAttribute('src', img.getAttribute('data-pc-src'));
        if (img.getAttribute('data-pc-srcset')) img.setAttribute('srcset', img.getAttribute('data-pc-srcset'));
        img.removeAttribute('data-pc-shown');
      }
    }
  }

  // Quick view modal (user 9/29): the theme's #modal-quickview-cart styled
  // as the PDP buy box (CSS at the end of custom-product-cards.css). This
  // adds what the CSS can't: the type line under the name (from the card
  // that opened it), the PDP-style thumb rail, a "Testers & samples" group
  // for wholesale variants, quantity + Add to Cart on one row with the
  // price on the button, and a Full details pill. Idempotent — nothing is
  // moved twice — so the 700ms groom loop never reflows the modal.
  var qvType = '';
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-quickview-trigger');
    if (!t) return;
    var tile = t.closest('.js-product-listing');
    var type = tile && tile.querySelector('.product_type');
    qvType = type ? type.textContent.replace(/ /g, ' ').trim() : '';
  });
  // the theme drops the product into #quickview-form after a fetch; groom it
  // the moment it lands (not at the next 700ms tick), then reveal it
  var qvObserved = false;
  function watchQuickView() {
    var form = document.getElementById('quickview-form');
    if (!form || qvObserved) return;
    qvObserved = true;
    new MutationObserver(function () { groomQuickView(); }).observe(form, { childList: true, subtree: true });
  }
  // --- quick view dropdown helpers (same markup / classes as the card's) ---
  function qvDropdownStale(dd, group) {
    var inputs = group.querySelectorAll('input.variants-input');
    var opts = dd.querySelectorAll('.pc-dd__opt');
    if (inputs.length !== opts.length) return true;
    for (var i = 0; i < opts.length; i++) if (opts[i].pcSource !== inputs[i]) return true;
    return false;
  }
  function buildQvDropdown(group) {
    var dd = document.createElement('div');
    dd.className = 'pc-dd';
    var field = document.createElement('button');
    field.type = 'button';
    field.className = 'pc-dd__field';
    field.setAttribute('aria-haspopup', 'listbox');
    field.setAttribute('aria-expanded', 'false');
    field.setAttribute('data-pc-prompt', 'Choose a size');
    var list = document.createElement('div');
    list.className = 'pc-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    var inputs = group.querySelectorAll('input.variants-input');
    if (inputs.length > 4) list.classList.add('pc-dd__list--scroll');
    for (var i = 0; i < inputs.length; i++) {
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'pc-dd__opt';
      opt.setAttribute('role', 'option');
      opt.pcSource = inputs[i];
      list.appendChild(opt);
    }
    dd.appendChild(list);
    dd.appendChild(field);
    group.classList.add('pc-dd-src');
    group.parentNode.insertBefore(dd, group.nextSibling);
    return dd;
  }
  function qvMoney(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  // the variant for this option value, given what the other options have
  // picked (falls back to any variant carrying the value)
  function qvVariantFor(pj, details, optIndex, value) {
    if (!pj || !pj.variants) return null;
    var picked = [];
    var wraps = details.querySelectorAll('[data-option-index]');
    for (var w = 0; w < wraps.length; w++) {
      var idx = parseInt(wraps[w].getAttribute('data-option-index'), 10) || 0;
      var on = wraps[w].querySelector('input.variants-input:checked');
      picked[idx] = on ? on.value : null;
    }
    picked[optIndex] = value;
    var loose = null;
    for (var v = 0; v < pj.variants.length; v++) {
      var opts = pj.variants[v].options || [pj.variants[v].option1, pj.variants[v].option2, pj.variants[v].option3];
      if (opts[optIndex] !== value) continue;
      if (!loose) loose = pj.variants[v];
      var all = true;
      for (var k = 0; k < opts.length; k++) if (picked[k] != null && opts[k] !== picked[k]) { all = false; break; }
      if (all) return { variant: pj.variants[v], exact: true };
    }
    // no variant for this value with the other picks (a shade that has no
    // tester, say): shown greyed, priced from the nearest match
    return loose ? { variant: loose, exact: false } : null;
  }
  function qvDescribe(input, details, pj, optIndex) {
    var hit = qvVariantFor(pj, details, optIndex, input.value);
    var variant = hit ? hit.variant : null;
    var photo = '';
    if (variant && variant.featured_image && variant.featured_image.src) {
      photo = variant.featured_image.src;
      if (photo.indexOf('//') === 0) photo = 'https:' + photo;
      photo += (photo.indexOf('?') < 0 ? '?' : '&') + 'width=80';
    }
    return { name: input.value, price: variant ? qvMoney(variant.price) : '', photo: photo, off: !!(variant && (!variant.available || !hit.exact)) };
  }
  function refreshQvDropdown(dd, group, details, pj, optIndex) {
    var field = dd.querySelector('.pc-dd__field');
    var opts = dd.querySelectorAll('.pc-dd__opt');
    var picked = null;
    for (var i = 0; i < opts.length; i++) {
      var src = opts[i].pcSource;
      var on = !!src.checked;
      if (on) picked = src;
      var info = qvDescribe(src, details, pj, optIndex);
      fillRow(opts[i], info);
      // every write below is guarded: the modal's form is under a
      // MutationObserver that re-runs this groom, so an unconditional
      // innerHTML write here would loop the page to a standstill
      if (!opts[i].querySelector('.pc-dd__end')) opts[i].insertAdjacentHTML('beforeend', '<span class="pc-dd__end"></span>');
      var endEl = opts[i].querySelector('.pc-dd__end');
      var wantEnd = on ? TICK : '';
      if (endEl.innerHTML !== wantEnd) endEl.innerHTML = wantEnd;
      var wantSel = on ? 'true' : 'false';
      if (opts[i].getAttribute('aria-selected') !== wantSel) opts[i].setAttribute('aria-selected', wantSel);
      if (opts[i].disabled !== info.off) opts[i].disabled = info.off;
    }
    if (!picked && opts.length) picked = opts[0].pcSource;
    if (picked) {
      fillRow(field, qvDescribe(picked, details, pj, optIndex));
      if (!field.querySelector('.pc-dd__end')) field.insertAdjacentHTML('beforeend', '<span class="pc-dd__end">' + CHEVRON + '</span>');
    }
  }

  // first real paragraph of a product description (Shogun markup: strip
  // tags, skip headings / short fragments), clipped to ~88 characters (two lines with the link) at
  // a word boundary with an ellipsis
  function qvIntroText(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    var junk = box.querySelectorAll('script, style, h1, h2, h3, h4, table, ul, ol');
    for (var j = 0; j < junk.length; j++) junk[j].parentNode.removeChild(junk[j]);
    var text = '';
    var paras = box.querySelectorAll('p, div, span');
    for (var i = 0; i < paras.length; i++) {
      var t = (paras[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length >= 60) { text = t; break; }
    }
    if (!text) text = (box.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    if (text.length > 88) text = text.slice(0, 88).replace(/\s+\S*$/, '').replace(/[,;:.\-–—]+$/, '') + '…';
    return text;
  }
  // Homepage featured section, 740–1100px (user 10/7): the thumb strip
  // goes under the photo when it can line up with the quantity + Add to
  // Cart row, or when the photo beside a vertical rail would be tiny;
  // otherwise the rail stays on the left. Computed from sizes that do not
  // depend on the current placement (column width, details column height)
  // so the answer never flip-flops — the earlier try-and-measure version
  // oscillated. In the under layout CSS pins the strip to the row's
  // bottom edge, where the buy row also sits, so the two align exactly.
  var RAIL_RANGE = window.matchMedia('(min-width: 740px) and (max-width: 1100px)');
  function railUnder(sec) {
    var on = false;
    if (RAIL_RANGE.matches && sec.querySelectorAll('.pc-qv-thumb').length > 1) {
      var col = sec.querySelector('.product__section-images');
      var details = sec.querySelector('.product__section-details');
      if (col && details) {
        var colW = col.clientWidth;
        var photoBeside = colW - 20 - 60;             /* column pads, rail 50 + gap 10 */
        var photoUnder = Math.min(340, colW - 20);    /* square photo, strip beneath */
        var underH = photoUnder + 10 + 42;           /* photo + gap + strip */
        var detailsH = details.offsetHeight;
        var tiny = photoBeside < 260;
        var fits = underH <= detailsH + 24;           /* the strip can reach the buy row */
        on = tiny || fits;
      }
    }
    if (sec.classList.contains('pc-rail-under') !== on) sec.classList.toggle('pc-rail-under', on);
  }
  // resize: re-groom on the next frame (not the 700ms tick) so the rail
  // placement, the buy-button icon and the thumb strip follow the window
  // as it is dragged, and tell Flickity to re-measure the galleries
  // (user 10/7 "choppy when making the screen smaller")
  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(function () {
      resizeFrame = 0;
      var sliders = document.querySelectorAll('.featured-product.product-template .slides.carousel, #modal-quickview-cart .slides.carousel');
      for (var i = 0; i < sliders.length; i++) {
        var f = window.Flickity && window.Flickity.data(sliders[i]);
        if (f) f.resize();
      }
      groomQuickView();
    });
  });
  function revealQuickView(modal) {
    var wrap = modal.querySelector('.product__quickview-wrapper');
    if (!wrap || wrap.classList.contains('pc-qv-ready') || wrap.dataset.pcRevealing) return;
    wrap.dataset.pcRevealing = '1';
    var slider = modal.querySelector('.slides.carousel');
    var tries = 0;
    (function settle() {
      var flk = slider && window.Flickity && window.Flickity.data(slider);
      if (flk) {
        flk.resize();
        // the rail's highlight follows the slider (a shade pick moves it to
        // the variant's photo); hooked here because the theme starts the
        // slider after the rail is built
        if (slider._pcMark && !slider._pcHooked) {
          slider._pcHooked = true;
          flk.on('select', function () { slider._pcMark(flk.selectedIndex); });
          slider._pcMark(flk.selectedIndex);
        }
      } else if (tries++ < 5) {
        return setTimeout(settle, 60); // the theme is still starting the slider
      }
      wrap.classList.add('pc-qv-ready');
    })();
  }
  function groomQuickView() {
    watchQuickView();
    var modal = document.getElementById('modal-quickview-cart');
    if (modal) {
      // whatever happens while arranging, the content is revealed
      try { groomQuickViewInner(modal); } catch (err) { if (window.console) console.warn('quick view groom', err); }
      revealQuickView(modal);
    }
    // the homepage featured product (sections/featured-product.liquid) gets
    // the same buy box (user 10/1)
    var featured = document.querySelectorAll('.featured-product.product-template');
    for (var f = 0; f < featured.length; f++) {
      try { groomQuickViewInner(featured[f]); } catch (err2) { if (window.console) console.warn('featured groom', err2); }
      try { railUnder(featured[f]); } catch (err3) { if (window.console) console.warn('featured rail', err3); }
      // the theme redraws the pill labels on a shade pick (soft tube ↔ new
      // airless); until the next 700ms tick the bold ghost still reserved
      // the OLD text's width, so the label sat off-centre for a beat (user
      // 10/6 "the pill text shifts weirdly"). Re-groom the moment the text
      // changes. Only childList / characterData are observed, and the
      // groom's own writes there (the sold-out reorder) settle in one pass.
      if (!featured[f].dataset.pcObserved) {
        featured[f].dataset.pcObserved = '1';
        (function (sec) {
          // synchronous: the callback runs before the next paint, so a
          // re-rendered pill never paints without its reserved width (a
          // deferred groom let it paint narrow for a frame, then widen —
          // the "words moving right" the user saw 10/6)
          var busy = false;
          new MutationObserver(function () {
            if (busy) return;
            busy = true;
            try { groomQuickView(); } finally { busy = false; }
          }).observe(sec.querySelector('.product__section-details') || sec, { childList: true, characterData: true, subtree: true });
          sec.addEventListener('change', function () { setTimeout(groomQuickView, 0); setTimeout(groomQuickView, 80); });
        })(featured[f]);
      }
    }
  }
  function groomQuickViewInner(modal) {
    var details = modal.querySelector('.product__section-details');
    if (!details) return;
    var header = details.querySelector('.product__section--header');
    var title = details.querySelector('.product__section-title');
    if (!header || !title) return;
    // type line under the name (PDP order: name, then type)
    var typeEl = header.querySelector('.pc-qv-type');
    if (!typeEl) {
      typeEl = document.createElement('span');
      typeEl.className = 'pc-qv-type';
      title.insertAdjacentElement('afterend', typeEl);
    }
    var typeText = qvType;
    if (modal.classList.contains('featured-product')) {
      // the section carries the product JSON (snippets/product-json)
      typeText = '';
      var scripts = modal.querySelectorAll('script[type="application/json"]');
      for (var si = 0; si < scripts.length; si++) {
        try {
          var pj = JSON.parse(scripts[si].textContent);
          if (pj && pj.type) { typeText = pj.type; break; }
          if (pj && pj.product && pj.product.type) { typeText = pj.product.type; break; }
        } catch (e) {}
      }
    }
    if (typeText && typeEl.textContent !== typeText) typeEl.textContent = typeText;
    // sizes: every variant the PDP offers, in the theme's own pill row —
    // testers, sample packs and Pro sizes included (user 9/30: "the quick
    // view should have the same options as the pdp")
    // quantity + Add to Cart on one row
    var qty = details.querySelector('.product__section--qty');
    var buttons = details.querySelector('.product__section--buttons');
    if (qty && buttons && !details.querySelector('.pc-qv-cta')) {
      var cta = document.createElement('div');
      cta.className = 'pc-qv-cta';
      details.insertBefore(cta, buttons);
      cta.appendChild(qty);
      cta.appendChild(buttons);
    }
    // "Full details" as a small link under the photo (user 9/30: a pill at
    // the foot of the details column stretched the modal); the title links
    // to the product too
    var titleLink = title.querySelector('a');
    var detailsHref = titleLink ? titleLink.getAttribute('href') : modal.getAttribute('data-url');
    var galleryCol = modal.querySelector('.product__section-images #slider') || modal.querySelector('.product__section-images');
    // modal (user 10/6): a one-to-two line intro from the product's own
    // description, ending in "… View full details", sits under the price;
    // no separate link at the foot of the column any more
    if (modal.id === 'modal-quickview-cart' && detailsHref && !details.querySelector('.pc-qv-intro')) {
      var priceBox = details.querySelector('.product__price-container');
      var introSrc = modal.querySelector('script.product-json');
      var introText = '';
      try {
        var introPj = introSrc ? JSON.parse(introSrc.textContent) : null;
        introText = introPj && introPj.description ? qvIntroText(introPj.description) : '';
      } catch (e1) { introText = ''; }
      if (priceBox) {
        var intro = document.createElement('p');
        intro.className = 'pc-qv-intro';
        if (introText) intro.appendChild(document.createTextNode(introText + ' '));
        var introLink = document.createElement('a');
        introLink.className = 'pc-qv-details';
        introLink.href = detailsHref;
        introLink.textContent = 'View full details';
        intro.appendChild(introLink);
        priceBox.insertAdjacentElement('afterend', intro);
        intro.dataset.pcText = introText;
      }
    }
    // fit the intro to two lines by measurement (a fixed character count
    // let caps-heavy names push the link onto a third line): drop words from
    // the end until the paragraph is two lines tall. Has to wait for layout —
    // the content is groomed while the modal is still hidden (offsetHeight
    // 0), so this runs on a later groom tick and only once (data-pc-fit).
    var introEl = details.querySelector('.pc-qv-intro');
    if (introEl && !introEl.dataset.pcFit && introEl.offsetHeight > 0 && introEl.firstChild && introEl.firstChild.nodeType === 3) {
      var lineH = parseFloat(getComputedStyle(introEl).lineHeight) || 19.5;
      var words = (introEl.dataset.pcText || '').replace(/…$/, '').split(' ');
      var guard = 0;
      while (introEl.offsetHeight > lineH * 2.5 && words.length > 6 && guard++ < 40) {
        words.pop();
        introEl.firstChild.nodeValue = words.join(' ').replace(/[,;:.\-–—]+$/, '') + '… ';
      }
      introEl.dataset.pcFit = '1';
    }
    if (modal.id !== 'modal-quickview-cart' && detailsHref && galleryCol && !modal.querySelector('.pc-qv-fine')) {
      var fine = document.createElement('div');
      fine.className = 'pc-qv-fine';
      var more = document.createElement('a');
      more.className = 'pc-qv-details';
      more.href = detailsHref;
      more.textContent = 'View full details';
      fine.appendChild(more);
      // modal (user 10/2): the link sits in the details column, just above
      // the quantity + Add to Cart row, now that the dropdown left room
      // there; the homepage section keeps it under the photo
      if (modal.id === 'modal-quickview-cart') details.appendChild(fine); else galleryCol.appendChild(fine);
    }
    // every option pill carries its own text as a bold ghost (CSS ::after)
    // so picking one never changes its width
    var pills = details.querySelectorAll('.dynamic-option-values label.swatches__form--label');
    for (var pi = 0; pi < pills.length; pi++) {
      var ghost = pills[pi].textContent.replace(/\s+/g, ' ').trim();
      if (pills[pi].getAttribute('data-pc-ghost') !== ghost) pills[pi].setAttribute('data-pc-ghost', ghost);
    }
    // − greys out at quantity 1 (PDP behaviour)
    var qtyWrap = details.querySelector('.product__quantity--wrapper');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('input.formQty');
      var atMin = function () { qtyWrap.classList.toggle('pc-at-min', !qtyInput || (parseInt(qtyInput.value, 10) || 1) <= 1); };
      if (!qtyWrap.dataset.pcMin) {
        qtyWrap.dataset.pcMin = '1';
        qtyWrap.addEventListener('click', function () { setTimeout(atMin, 0); });
        qtyWrap.addEventListener('input', atMin);
        qtyWrap.addEventListener('change', atMin);
      }
      atMin();
    }
    // price on the button ("Add to Cart · $59"), following the live price
    var add = details.querySelector('#addToCart, input.AddtoCart');
    if (add && !add.disabled) {
      var readPrice = function () {
        var sale = details.querySelector('.price__sale');
        var priceEl = (sale && sale.offsetHeight) ? sale.querySelector('.price-item--sale') : details.querySelector('.price__regular .price-item--regular');
        return (priceEl ? priceEl.textContent : '').trim().replace(/\.00\b/, '');
      };
      var placeIcon = function () {
        // the bag icon hugs the label: icon + text read as one centred group
        // (a fixed inset left a gap that changed with the label's length)
        var bw = add.clientWidth;
        var key = add.value + '|' + bw;
        if (add.dataset.pcIconFor === key) return;
        add.dataset.pcIconFor = key;
        var cv = document.createElement('canvas').getContext('2d');
        var cs = getComputedStyle(add);
        cv.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        var tw = cv.measureText(add.value).width;
        // icon (16px) + 10px gap + label form one group, centred in the
        // button: the slack either side of that group becomes the right pad;
        // the left pad adds the icon + gap; the icon sits at the left pad
        // edge. Exact at any width (the old 46/20 + offset maths drifted
        // once the pads had to shrink — user 10/7 "button not centred").
        var group = tw + 26;
        var slack = bw ? bw - group : 40;
        if (bw && slack < 10) {
          // no room for the icon: label alone, centred
          add.style.paddingLeft = '12px';
          add.style.paddingRight = '12px';
          add.style.textIndent = '0';
          add.style.backgroundImage = 'none';
          return;
        }
        add.style.backgroundImage = '';
        var padR = Math.max(8, Math.round(slack / 2));
        add.style.paddingLeft = (padR + 26) + 'px';
        add.style.paddingRight = padR + 'px';
        add.style.textIndent = '0';
        add.style.backgroundPosition = padR + 'px center';
      };
      var syncLabel = function () {
        var price = readPrice();
        var base = add.value.replace(/\s*·.*$/, '');
        var want = /add to cart/i.test(base) && price ? 'Add to Cart · ' + price : base;
        if (add.value !== want) add.value = want;
        placeIcon();
      };
      // the theme rewrites the label to a bare "Add to cart" on every
      // variant change, and the price only came back on the next groom tick
      // — a visible flicker (user 10/2 "looks weird when clicking on
      // different options"). Decorate the theme's own write the moment it
      // happens, then re-check once its price line has settled.
      if (!add._pcValueHooked) {
        add._pcValueHooked = true;
        var proto = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
        if (proto && proto.set && proto.get) {
          Object.defineProperty(add, 'value', {
            configurable: true,
            get: function () { return proto.get.call(this); },
            set: function (v) {
              var text = String(v);
              if (/^add to cart$/i.test(text.trim())) {
                var price = readPrice();
                if (price) text = 'Add to Cart · ' + price;
              }
              proto.set.call(this, text);
              placeIcon();
              setTimeout(syncLabel, 0);
            }
          });
        }
      }
      syncLabel();
    }
    // size / type options as the card's dropdown (user 10/2 "make the quick
    // view selection containers like the card dropdown"): the theme's radio
    // pills stay in the DOM (hidden via .pc-dd-src); a pick clicks the
    // matching radio so the theme keeps doing the variant / price work.
    // Shades stay circles. Modal only — the homepage section keeps PDP pills.
    // (modal only — a dropdown was tried on the homepage featured section
    // 10/6 and rejected: "just make it be like the pdp")
    if (modal.id === 'modal-quickview-cart') {
      var pjEl = modal.querySelector('script.product-json');
      var pj = null;
      try { pj = pjEl ? JSON.parse(pjEl.textContent) : null; } catch (e0) { pj = null; }
      var groups = details.querySelectorAll('.dynamic-option-values');
      for (var gi = 0; gi < groups.length; gi++) {
        var qGroup = groups[gi];
        var qWrap = qGroup.closest('[data-option-index]');
        if (!qWrap || qWrap.classList.contains('is-color-option')) continue;
        var qIndex = parseInt(qWrap.getAttribute('data-option-index'), 10) || 0;
        // one value only: nothing to choose, so no dropdown — the "SIZE:
        // 2.4 fl oz - 70 ml" heading line says what it is (user 10/6)
        if (qGroup.querySelectorAll('input.variants-input').length < 2) {
          qGroup.classList.add('pc-dd-src');
          var stale = qGroup.nextSibling && qGroup.nextSibling.classList && qGroup.nextSibling.classList.contains('pc-dd') ? qGroup.nextSibling : null;
          if (stale) stale.parentNode.removeChild(stale);
          continue;
        }
        var qdd = qGroup.nextSibling && qGroup.nextSibling.classList && qGroup.nextSibling.classList.contains('pc-dd') ? qGroup.nextSibling : null;
        if (qdd && qvDropdownStale(qdd, qGroup)) { qdd.parentNode.removeChild(qdd); qdd = null; }
        if (!qdd) qdd = buildQvDropdown(qGroup);
        refreshQvDropdown(qdd, qGroup, details, pj, qIndex);
      }
    }
    // homepage featured section: pills exactly as the PDP lays them out
    // (sections/main-product.liquid balance()): available options lead,
    // sold-out pills move to the end in their own order, so a shade pick
    // never reshuffles the rows (user 10/6)
    if (modal.classList.contains('featured-product')) {
      var pillGroups = details.querySelectorAll('.is-pill-option .dynamic-option-values');
      for (var pg = 0; pg < pillGroups.length; pg++) {
        var container = pillGroups[pg];
        var pairs = [].slice.call(container.querySelectorAll('label.swatches__form--label')).map(function (l) {
          var prev = l.previousElementSibling;
          return { label: l, input: (prev && prev.tagName === 'INPUT') ? prev : null, na: l.classList.contains('not-available') };
        });
        var misplaced = pairs.some(function (p, i) { return p.na && pairs.slice(i + 1).some(function (q) { return !q.na; }); });
        if (misplaced) {
          pairs.filter(function (p) { return !p.na; }).concat(pairs.filter(function (p) { return p.na; })).forEach(function (p) {
            if (p.input) container.appendChild(p.input);
            container.appendChild(p.label);
          });
        }
      }
    }
    // thumb rail (the theme renders arrows only): all photos in a rail with
    // the PDP's up / down arrows above and below (user 9/29); the arrows
    // step the slider, the rail scrolls the active thumb into view
    var gallery = modal.querySelector('.product__section-images');
    var slider = gallery && gallery.querySelector('.slides.carousel');
    if (slider && gallery.querySelector('.pc-qv-thumbs') && slider._pcMark && window.Flickity) {
      var flkSync = window.Flickity.data(slider);
      var listSync = gallery.querySelector('.pc-qv-thumbs__list');
      // the first mark often runs while the modal is still hidden (zero
      // widths → nothing to scroll); once the list has layout, bring the
      // selected thumb into view, once per selection (user 10/7)
      if (flkSync && listSync && listSync.clientWidth > 0 && listSync.dataset.pcSynced !== String(flkSync.selectedIndex)) {
        listSync.dataset.pcSynced = String(flkSync.selectedIndex);
        slider._pcMark(flkSync.selectedIndex, true);
      }
    }
    if (slider && !gallery.querySelector('.pc-qv-thumbs')) {
      var cells = slider.querySelectorAll('.js-main-carousel-cell img');
      if (cells.length > 1) {
        var rail = document.createElement('div');
        rail.className = 'pc-qv-thumbs';
        var list = document.createElement('div');
        list.className = 'pc-qv-thumbs__list';
        var flk = function () { return window.Flickity && window.Flickity.data(slider); };
        var mark = function (index, instant) {
          var all = list.querySelectorAll('.pc-qv-thumb');
          for (var k = 0; k < all.length; k++) {
            all[k].classList.toggle('is-active', k === index);
            if (k === index && all[k].scrollIntoView) {
              // the rail is a column on desktop and a ROW on phones / in the
              // stacked modal — scroll along whichever axis it runs, so the
              // selected thumb is always in view (user 10/7: the variant's
              // photo was selected but its thumb sat off the end of the row)
              var horiz = (getComputedStyle(list).flexDirection || '').indexOf('row') === 0;
              if (horiz) {
                var left = all[k].offsetLeft - list.offsetLeft;
                if (left < list.scrollLeft || left + all[k].offsetWidth > list.scrollLeft + list.clientWidth) {
                  list.scrollTo({ left: left - (list.clientWidth - all[k].offsetWidth) / 2, behavior: instant ? 'auto' : 'smooth' });
                }
              } else {
                var top = all[k].offsetTop - list.offsetTop;
                if (top < list.scrollTop || top + all[k].offsetHeight > list.scrollTop + list.clientHeight) {
                  list.scrollTo({ top: top - (list.clientHeight - all[k].offsetHeight) / 2, behavior: instant ? 'auto' : 'smooth' });
                }
              }
            }
          }
          rail.classList.toggle('pc-qv-thumbs--at-start', index === 0);
          rail.classList.toggle('pc-qv-thumbs--at-end', index === all.length - 1);
        };
        var arrow = function (dir) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pc-qv-thumb-arrow pc-qv-thumb-arrow--' + dir;
          b.setAttribute('aria-label', dir === 'up' ? 'Previous photo' : 'Next photo');
          b.innerHTML = dir === 'up'
            ? '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
          b.addEventListener('click', function () {
            var f = flk();
            if (!f) return;
            if (dir === 'up') f.previous(); else f.next();
            mark(f.selectedIndex);
          });
          return b;
        };
        for (var c = 0; c < cells.length; c++) {
          (function (index) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pc-qv-thumb' + (index === 0 ? ' is-active' : '');
            b.setAttribute('aria-label', 'Photo ' + (index + 1));
            var im = document.createElement('img');
            im.src = cells[index].currentSrc || cells[index].src || cells[index].getAttribute('data-src') || '';
            im.alt = '';
            b.appendChild(im);
            b.addEventListener('click', function () {
              var f = flk();
              if (f) f.select(index);
              mark(index);
            });
            list.appendChild(b);
          })(c);
        }
        rail.appendChild(arrow('up'));
        rail.appendChild(list);
        rail.appendChild(arrow('down'));
        gallery.appendChild(rail);
        slider._pcMark = mark;
        slider._pcHooked = false;
        mark(0);
      }
    }
    // the rail's highlight follows the slider wherever the buy box lives:
    // the modal hooks in revealQuickView(); the homepage featured section
    // never went through that, so a shade pick moved the photo but not the
    // highlight (user 10/2 "the image on the left isn't consistent with the
    // main image"). groom() ticks keep retrying until the theme has started
    // the slider.
    if (slider && slider._pcMark && !slider._pcHooked && window.Flickity) {
      var flkNow = window.Flickity.data(slider);
      if (flkNow) {
        slider._pcHooked = true;
        flkNow.on('select', function () { slider._pcMark(flkNow.selectedIndex); });
        slider._pcMark(flkNow.selectedIndex);
        // late-loading photos: re-measure the slider once each one is in
        for (var li = 0; li < cells.length; li++) {
          if (!cells[li].complete) cells[li].addEventListener('load', function () { var f = flk(); if (f) f.resize(); });
        }
      }
    }
  }

  // ® / ™ in product names ride as small raised marks (user 10/7 "make
  // sure trademarks/symbols are going in the right place"): each mark is
  // wrapped in <span class="pc-tm">; idempotent (skips titles already
  // wrapped or carrying the PDP's own <sup>)
  function pcWrapMarks(el) {
    if (!el || el.querySelector('.pc-tm, sup')) return;
    if (!/[\u00ae\u2122]/.test(el.textContent)) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) if (/[\u00ae\u2122]/.test(n.nodeValue)) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i], parts = t.nodeValue.split(/([\u00ae\u2122])/), frag = document.createDocumentFragment();
      for (var j = 0; j < parts.length; j++) {
        if (!parts[j]) continue;
        if (parts[j] === '\u00ae' || parts[j] === '\u2122') {
          var sp = document.createElement('span'); sp.className = 'pc-tm'; sp.textContent = parts[j]; frag.appendChild(sp);
        } else frag.appendChild(document.createTextNode(parts[j]));
      }
      t.parentNode.replaceChild(frag, t);
    }
  }

  // 10/8 (user: "the symbol is still in the wrong place", mega menu
  // "WONDER WASH®"): the selector list above missed the mega menu rows and
  // featured card, the mobile menu card, shade chooser titles, Protocols
  // bundle headings… so every visible ® / ™ on the page is raised now, text
  // node by text node, cart drawer included (user 10/8: "fix the symbols in
  // the cart drawer"). Left alone: screen-reader only text, form
  // fields/options, marks already in a <sup> or .pc-tm.
  var PC_TM_SKIP = 'script,style,noscript,title,option,select,textarea,sup,svg,.pc-tm,' +
    '.visuallyhidden,.visually-hidden,.sr-only,[contenteditable]';
  function pcMarkOk(t) {
    if (!/[\u00ae\u2122]/.test(t.nodeValue)) return false;
    var pe = t.parentElement;
    return !!pe && !pe.closest(PC_TM_SKIP);
  }
  function pcWrapMarksEverywhere() {
    if (document.body) pcWrapMarksIn(document.body);
  }
  function pcWrapMarksIn(root) {
    var nodes = [], n;
    if (root.nodeType === 3) {
      if (pcMarkOk(root)) nodes.push(root);
    } else if (root.nodeType === 1 && /[\u00ae\u2122]/.test(root.textContent)) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (t) { return pcMarkOk(t) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
      });
      while ((n = walker.nextNode())) nodes.push(n);
    }
    if (!nodes.length) return;
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i], parts = t.nodeValue.split(/([\u00ae\u2122])/), frag = document.createDocumentFragment();
      for (var j = 0; j < parts.length; j++) {
        if (!parts[j]) continue;
        if (parts[j] === '\u00ae' || parts[j] === '\u2122') {
          var sp = document.createElement('span'); sp.className = 'pc-tm'; sp.textContent = parts[j]; frag.appendChild(sp);
        } else frag.appendChild(document.createTextNode(parts[j]));
      }
      var host = t.parentNode;
      if (!host) continue;
      // in a flex / grid box every child is its own item, so a bare span
      // would drop the mark onto its own line (cart drawer GWP title, user
      // 10/8 "this is wrong"); keep name + mark together in one inline run
      var hd = host.nodeType === 1 ? getComputedStyle(host).display : '';
      if (/flex|grid/.test(hd)) {
        // a custom tag, not a span: the cart drawer styles every span in an
        // item title as the grey sub-line, which turned the name grey
        var run = document.createElement('pc-run');
        run.appendChild(frag);
        host.replaceChild(run, t);
      } else host.replaceChild(frag, t);
    }
  }

  // The cart drawer (and other widgets) redraw their HTML on open / cart
  // change; the 700ms groom then raised the marks a beat later, so the flat
  // ® / ™ flashed first (user 10/8 "for a split second the symbols and
  // titles glitch as they used to be"). Mutation observer callbacks run as a
  // microtask, before the browser paints, so new content is wrapped before
  // it is ever shown. The callback only walks the nodes that were added or
  // whose text changed; its own replacements contain no bare marks, so they
  // settle immediately.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var ri = 0; ri < records.length; ri++) {
        var rec = records[ri];
        if (rec.type === 'characterData') { pcWrapMarksIn(rec.target); continue; }
        for (var ai = 0; ai < rec.addedNodes.length; ai++) {
          var an = rec.addedNodes[ai];
          if (an.isConnected) pcWrapMarksIn(an);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  function groom() {
    pcWrapMarksEverywhere();
    // Protocols carousels: arrows sit on the photo's centre line (user 10/7
    // "make these arrows centered w the products") — measured, since the
    // photo is a share of the cell width and CSS top% follows height
    var pcars = document.querySelectorAll('.am-protocol-carousel.flickity-enabled');
    for (var pi = 0; pi < pcars.length; pi++) {
      var pcar = pcars[pi];
      var pr = pcar.getBoundingClientRect();
      if (!pr.width) continue;
      var pimg = pcar.querySelector('.is-selected .prod-image img') || pcar.querySelector('.prod-image img');
      if (!pimg) continue;
      var ir = pimg.getBoundingClientRect();
      if (!ir.height) continue;
      var ptop = Math.round(ir.top + ir.height / 2 - pr.top) + 'px';
      if (pcar.style.getPropertyValue('--pc-arrow-top') !== ptop) pcar.style.setProperty('--pc-arrow-top', ptop);
    }
    groomQuickView();
    if (pageExcluded()) return;
    var list = cards();
    if (list.length) groomAddButtons(list);
    var choosers = chooserCards();
    if (!choosers.length) return;
    groomChooserButtons(choosers);
    groomChoosers(choosers);
    groomDropdowns(choosers);
    fitPhotos(choosers);
    syncCardPhotos(choosers);
  }

  // Chooser dropdowns (user 9/28, canvas "Chooser D"): each choice list —
  // sizes (incl. B2B testers / packs / Pro), the wholesale BB size row and
  // the marketing quantity / type rows — collapses into one dropdown row:
  // photo, name, price, chevron. It opens upward over the product photo
  // into a scrolling list. The theme's own buttons stay in the DOM (hidden
  // via .pc-dd-src) and a pick clicks the matching one, so custom.js and
  // syncTypeRow() keep doing the variant / buy-button work. BB shades stay
  // circles. All chooser tiles (chooserCards()).
  var DD_GROUPS = [
    { group: '.shade-chooser--size .shade-chooser__sizes', option: '.shade-chooser__size' },
    { group: '.js-pc-type-group', option: '.js-pc-type' },
    { group: '.js-marketing-option-group', option: '.js-marketing-option' }
  ];
  var CHEVRON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>';
  var TICK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>';

  function bgUrl(el) {
    var m = (el.getAttribute('style') || '').match(/url\(\s*['"]?([^'")]+)['"]?\s*\)/);
    return m ? m[1] : '';
  }

  function isPicked(src) {
    return src.classList.contains('is-selected') || src.getAttribute('aria-pressed') === 'true';
  }

  function isOff(src) {
    return src.disabled || src.classList.contains('not-available');
  }

  // name / price / photo for one source button
  function describe(src, chooser, card) {
    var fallback = card.querySelector('.prod-image img');
    var photo = fallback ? (fallback.currentSrc || fallback.src) : '';
    var price = '';
    var name;
    if (src.classList.contains('js-pc-type')) {
      var key = src.getAttribute('data-type-key') || '';
      name = shortSize(key);
      var shadeBtn = chooser.querySelector('.js-shade-qv-swatch.is-selected');
      var shade = shadeBtn ? shadeBtn.getAttribute('data-shade') : '';
      var spans = chooser.querySelectorAll('.js-pc-type-variant');
      for (var i = 0; i < spans.length; i++) {
        if (spans[i].getAttribute('data-shade') === shade && spans[i].getAttribute('data-type-key') === key) {
          price = spans[i].getAttribute('data-price') || '';
          if (spans[i].getAttribute('data-image')) photo = spans[i].getAttribute('data-image');
          break;
        }
      }
    } else if (src.classList.contains('js-marketing-option')) {
      name = src.getAttribute('data-option-value') || src.textContent.trim();
      photo = bgUrl(src);
    } else {
      name = shortSize(src.getAttribute('data-shade') || '');
      price = src.getAttribute('data-price') || '';
      photo = bgUrl(src) || photo;
    }
    return { name: name, price: price.replace(/\.00$/, ''), photo: photo };
  }

  function fillRow(el, info) {
    var html = '';
    html += info.photo ? '<span class="pc-dd__th"><img src="' + info.photo + '" alt="" loading="lazy"></span>' : '<span class="pc-dd__th pc-dd__th--none"></span>';
    html += '<span class="pc-dd__nm"></span>';
    html += '<span class="pc-dd__pr"></span>';
    if (el.getAttribute('data-pc-row') !== info.name + '|' + info.price + '|' + info.photo) {
      var tail = el.querySelector('.pc-dd__end');
      var tailHtml = tail ? tail.outerHTML : '';
      el.innerHTML = html + tailHtml;
      el.querySelector('.pc-dd__nm').textContent = info.name;
      el.querySelector('.pc-dd__pr').textContent = info.price;
      el.setAttribute('data-pc-row', info.name + '|' + info.price + '|' + info.photo);
    }
  }

  function buildDropdown(group, optionSel) {
    var dd = document.createElement('div');
    dd.className = 'pc-dd';
    var field = document.createElement('button');
    field.type = 'button';
    field.className = 'pc-dd__field';
    field.setAttribute('aria-haspopup', 'listbox');
    field.setAttribute('aria-expanded', 'false');
    // shown in place of the picked row while the list is open, so the pick
    // isn't listed twice (the list's check mark marks it)
    field.setAttribute('data-pc-prompt', group.classList.contains('js-marketing-option-group') ? 'Choose an option' : 'Choose a size');
    var list = document.createElement('div');
    list.className = 'pc-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    var sources = group.querySelectorAll(optionSel);
    // up to 4 options always show in full; only longer lists scroll (and
    // get the scroll cue) — user 9/28
    if (sources.length > 4) list.classList.add('pc-dd__list--scroll');
    for (var i = 0; i < sources.length; i++) {
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'pc-dd__opt';
      opt.setAttribute('role', 'option');
      opt.pcSource = sources[i];
      list.appendChild(opt);
    }
    dd.appendChild(list);
    dd.appendChild(field);
    group.classList.add('pc-dd-src');
    group.parentNode.insertBefore(dd, group.nextSibling);
    dd.pcGroup = group;
    return dd;
  }

  function refreshDropdown(dd, chooser, card) {
    var field = dd.querySelector('.pc-dd__field');
    var opts = dd.querySelectorAll('.pc-dd__opt');
    var picked = null;
    for (var i = 0; i < opts.length; i++) {
      var src = opts[i].pcSource;
      var on = isPicked(src);
      if (on) picked = src;
      fillRow(opts[i], describe(src, chooser, card));
      if (!opts[i].querySelector('.pc-dd__end')) opts[i].insertAdjacentHTML('beforeend', '<span class="pc-dd__end"></span>');
      opts[i].querySelector('.pc-dd__end').innerHTML = on ? TICK : '';
      opts[i].setAttribute('aria-selected', on ? 'true' : 'false');
      opts[i].disabled = isOff(src);
    }
    if (!picked && opts.length) picked = opts[0].pcSource;
    if (picked) {
      fillRow(field, describe(picked, chooser, card));
      if (!field.querySelector('.pc-dd__end')) field.insertAdjacentHTML('beforeend', '<span class="pc-dd__end">' + CHEVRON + '</span>');
    }
  }

  // Scroll cue for lists that don't fit (B2B sizes, Daily Wonder…): fades +
  // a chevron at whichever end has more rows; --pc-dd-list-h places the top
  // cue at the list's top edge (the list opens upward over the field).
  function updateScrollCue(dd) {
    var list = dd.querySelector('.pc-dd__list');
    if (!list || list.hidden) return;
    var more = list.classList.contains('pc-dd__list--scroll') && list.scrollHeight - list.clientHeight > 2;
    dd.style.setProperty('--pc-dd-list-h', list.offsetHeight + 'px');
    dd.classList.toggle('pc-dd--more-below', more && list.scrollTop + list.clientHeight < list.scrollHeight - 2);
    dd.classList.toggle('pc-dd--more-above', more && list.scrollTop > 2);
  }

  document.addEventListener('scroll', function (e) {
    var list = e.target;
    if (list && list.classList && list.classList.contains('pc-dd__list')) updateScrollCue(list.parentNode);
  }, true);

  function closeDropdowns(except) {
    var open = document.querySelectorAll('.pc-dd.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] === except) continue;
      open[i].classList.remove('is-open');
      open[i].querySelector('.pc-dd__list').hidden = true;
      open[i].querySelector('.pc-dd__field').setAttribute('aria-expanded', 'false');
    }
  }

  function groomDropdowns(list) {
    for (var i = 0; i < list.length; i++) {
      var chooser = list[i].querySelector('.js-shade-chooser');
      if (!chooser) continue;
      for (var g = 0; g < DD_GROUPS.length; g++) {
        var groups = chooser.querySelectorAll(DD_GROUPS[g].group);
        for (var k = 0; k < groups.length; k++) {
          var group = groups[k];
          var dd = group.nextSibling && group.nextSibling.classList && group.nextSibling.classList.contains('pc-dd') ? group.nextSibling : null;
          if (!dd) dd = buildDropdown(group, DD_GROUPS[g].option);
          refreshDropdown(dd, chooser, list[i]);
          // a closed chooser never keeps an open list
          if (chooser.hidden && dd.classList.contains('is-open')) {
            dd.classList.remove('is-open');
            dd.querySelector('.pc-dd__list').hidden = true;
            dd.querySelector('.pc-dd__field').setAttribute('aria-expanded', 'false');
          }
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var field = e.target.closest('.pc-dd__field');
    var opt = e.target.closest('.pc-dd__opt');
    if (e.target.closest('.js-shade-chooser-close, [data-quick-add]')) closeDropdowns();
    if (field) {
      var dd = field.parentNode;
      var open = !dd.classList.contains('is-open');
      closeDropdowns(dd);
      dd.classList.toggle('is-open', open);
      dd.querySelector('.pc-dd__list').hidden = !open;
      field.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var sel = dd.querySelector('.pc-dd__opt[aria-selected="true"]');
        if (sel) sel.scrollIntoView({ block: 'nearest' });
        updateScrollCue(dd);
      }
      return;
    }
    if (opt) {
      if (opt.disabled) return;
      opt.pcSource.click();
      closeDropdowns();
      setTimeout(groom, 0);
      setTimeout(groom, 60);
      return;
    }
    if (!e.target.closest('.pc-dd')) closeDropdowns();
  });

  // Add to Cart feedback in the chooser (user 9/28: "doesn't really give any
  // feedback when pressed"). custom.js does the add (disables the button,
  // POSTs /cart/add.js, then closes the chooser and opens the cart drawer).
  // Here the button reads "Adding…" while that request is in flight, then
  // "Added ✓" — the chooser is held on screen ~0.9s (data-pc-added) so the
  // confirmation is seen before it fades. A failed add just resets.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var buy = e.target.closest('.js-shade-qv-buy');
    if (!buy || !buy.dataset.variantId || buy.hasAttribute('data-pc-adding')) return;
    var panel = buy.closest('.js-shade-chooser');
    if (!panel || panel.hidden) return;
    buy.setAttribute('data-pc-adding', '');
    var started = Date.now();
    var watch = setInterval(function () {
      if (panel.hidden) {
        clearInterval(watch);
        buy.removeAttribute('data-pc-adding');
        buy.setAttribute('data-pc-added', '');
        panel.setAttribute('data-pc-added', '');
        setTimeout(function () {
          panel.removeAttribute('data-pc-added');
          buy.removeAttribute('data-pc-added');
        }, 900);
      } else if ((!buy.disabled && Date.now() - started > 150) || Date.now() - started > 10000) {
        clearInterval(watch);
        buy.removeAttribute('data-pc-adding');
      }
    }, 60);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('.pc-dd.is-open')) closeDropdowns();
  });

  // Wholesale BB size row (snippets/product-listing.liquid .js-pc-type-group):
  // after custom.js has handled a shade click (it points the buy button at
  // the shade's full size), re-point it at the variant for the picked shade
  // + picked size, and disable sizes the shade doesn't come in.
  function syncTypeRow(panel) {
    var group = panel && panel.querySelector('.js-pc-type-group');
    if (!group) return;
    var shadeBtn = panel.querySelector('.js-shade-qv-swatch.is-selected');
    if (!shadeBtn) return;
    var shade = shadeBtn.getAttribute('data-shade');
    var variants = panel.querySelectorAll('.js-pc-type-variant');
    var types = group.querySelectorAll('.js-pc-type');
    var picked = group.querySelector('.js-pc-type[aria-pressed="true"]');
    var match = function (key) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].getAttribute('data-shade') === shade && variants[i].getAttribute('data-type-key') === key) return variants[i];
      }
      return null;
    };
    for (var t = 0; t < types.length; t++) {
      types[t].disabled = !match(types[t].getAttribute('data-type-key'));
    }
    if (!picked || picked.disabled) {
      picked = group.querySelector('.js-pc-type:not(:disabled)');
      for (var u = 0; u < types.length; u++) types[u].setAttribute('aria-pressed', types[u] === picked ? 'true' : 'false');
    }
    if (!picked) return;
    var key = picked.getAttribute('data-type-key');
    var variant = match(key);
    var buy = panel.querySelector('.js-shade-qv-buy');
    if (!variant || !buy) return;
    var label = (shade + (key === 'Full size' ? '' : ' ' + key)).toUpperCase();
    buy.dataset.variantId = variant.getAttribute('data-variant-id');
    if (variant.getAttribute('data-available') === 'true') {
      buy.disabled = false;
      buy.textContent = 'ADD ' + label + '  •  ' + variant.getAttribute('data-price');
    } else {
      buy.disabled = true;
      buy.textContent = label + ' - SOLD OUT';
    }
    var details = panel.querySelector('.js-shade-qv-details');
    if (details) details.href = variant.getAttribute('data-url');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var type = e.target.closest('.js-pc-type');
    if (type && !type.disabled) {
      var buttons = type.parentNode.querySelectorAll('.js-pc-type');
      for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-pressed', buttons[i] === type ? 'true' : 'false');
      syncTypeRow(type.closest('.js-shade-chooser'));
      setTimeout(groom, 0);
      return;
    }
    // shade clicks (and the chooser opening, which clicks the first shade):
    // let custom.js update the buy button first, then apply the size
    var swatch = e.target.closest('.js-shade-qv-swatch, [data-quick-add]');
    if (swatch) {
      setTimeout(function () {
        var tile = swatch.closest('.js-product-listing');
        syncTypeRow(tile && tile.querySelector('.js-shade-chooser'));
        groom();
      }, 0);
    }
  });

  // Nav height → --pc-nav-h (the CSS sizes the page's top padding from it).
  // Measured only while the page is at the top: the sticky nav collapses
  // its announcement bar once scrolled, and that is not the height to
  // reserve. Left unset (CSS fallback) if the page loads mid-scroll.
  function navHeight() {
    if (window.pageYOffset > 0) return;
    var hdr = document.querySelector('.shopify-section[id$="__header"], #shopify-section-header, .header-section');
    if (!hdr) return;
    var h = Math.round(hdr.getBoundingClientRect().height);
    if (h < 40) return;
    var val = h + 'px';
    if (document.documentElement.style.getPropertyValue('--pc-nav-h') !== val) {
      document.documentElement.style.setProperty('--pc-nav-h', val);
    }
  }
  // Page titles typed in ALL CAPS ("BEST SELLERS", "MINIS", "BACK BAR")
  // read as title case, like every other page header (user 9/29: caps
  // consistent). CSS capitalize only fixes lowercase text; this only touches
  // titles that are entirely upper case. Brand-style tokens stay as typed.
  var TITLE_SEL = '.collection__page-title, .pc-page-title, .blog-banner__title, ' +
    '.sample-pack-products__heading, .travel-size-products__heading, .pro-size-products__heading, .section__page-title, ' +
    '.shopify-policy__title h1, .custom-contact-title, .how-to-shop-title, ' +
    '.s4com-helpcenter-title, body.template-blog #MainContent h1.desktop-12, ' +
    '#MainContent > .shopify-section:first-child .image-slider-section__heading';
  var KEEP_CAPS = /^(BB|UV|USA|LLC|FAQS?|SPF|PRO|II|III|IV|B2B)$/;
  function titleCase(text) {
    return text.replace(/[A-Za-z][A-Za-z'’]*/g, function (w) {
      if (KEEP_CAPS.test(w)) return w;
      return w.charAt(0) + w.slice(1).toLowerCase();
    });
  }
  function titleCaseCaps() {
    var els = document.querySelectorAll(TITLE_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.pcCased || el.children.length) continue;
      var t = el.textContent;
      if (!/[A-Za-z]/.test(t) || t !== t.toUpperCase()) continue;
      el.textContent = titleCase(t);
      el.dataset.pcCased = '1';
    }
  }
  titleCaseCaps();
  document.addEventListener('DOMContentLoaded', titleCaseCaps);

  navHeight();
  document.addEventListener('DOMContentLoaded', navHeight);
  window.addEventListener('load', function () { navHeight(); setTimeout(navHeight, 600); });
  window.addEventListener('resize', navHeight);

  groom();
  document.addEventListener('DOMContentLoaded', groom);
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.js-product-listing')) return;
    [0, 80, 200].forEach(function (ms) { setTimeout(groom, ms); });
  });
  setInterval(groom, 700);
})();
